module.exports = __webpack_public_path__ + "img/document-nothing.0f9dd6e7.svg";